import { makeAutoObservable } from 'mobx';

class SignatureViewModel {
  id;
  name;
  signatureData;
  annotationType;
  signatureId;
  assignee;
  color;

  constructor({name, signatureData, signatureId, annotationType, assignee, color, id}) {
    makeAutoObservable(this);

    this.name = name;
    this.signatureData = signatureData;
    this.annotationType = annotationType;
    this.signatureId = signatureId;
    this.assignee = assignee;
    this.color = color;
    this.id = id;
  }

  static fromCompanySignature(companySignature) {
    return new SignatureViewModel({
      name: companySignature.name,
      signatureData: companySignature.signatureData,
      signatureId: companySignature.id,
      annotationType: 'company_signature'
    });
  }

  static employeeSignature(id, assignee, color) {
    return new SignatureViewModel({
      name: 'components.pdf.annotate.toolbar.Signature',
      annotationType: 'employee_signature',
      id,
      assignee,
      color
    });
  }
}

export default SignatureViewModel;
